module.exports = __webpack_public_path__ + "static/shaka-no-bg.879a74f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shaka-no-bg.svg
// module id = 1311
// module chunks = 168707334958949